import React from 'react'

import styles from './item-row.module.scss'

export const ItemsRow = ({ children }) => {
  return <div className={styles.itemRow}>{children}</div>
}

export const ItemRow = ({ title, amount, styleTitle, styleAmount, bold }) => {
  const boldClass = bold ? styles.bold : ''

  return (
    <div className={styles.item}>
      <span className={`${styles.itemTitle} ${boldClass}`} style={styleTitle}>
        {title}
      </span>
      <span className={`${styles.itemAmount} ${boldClass}`} style={styleAmount}>
        {amount}
      </span>
    </div>
  )
}
